// Dutch (NL)
export const nl = {
  // Navigation
  home: "Home",
  back: "Terug",
  products: "Producten",
  contact: "Contact",
  support: "Ondersteuning",
  login: "Inloggen",
  register: "Registreren",
  admin: "Admin",
  logout: "Uitloggen",

  // Home Page
  fastDelivery: "Snelle Bezorging",
  viewProducts: "Bekijk Producten",
  getInTouch: "Neem Contact Op",

  // Products
  allProducts: "Alle Producten",
  addToCart: "Toevoegen aan Winkelwagen",
  price: "Prijs",
  originalPrice: "Originele Prijs",
  quantity: "Hoeveelheid",
  reviews: "Beoordelingen",

  // Product Detail
  productDetails: "Productdetails",
  weight: "Gewicht",
  shelfLife: "Houdbaarheid",
  ingredients: "Ingrediënten",
  allergens: "Allergenen",
  aboutProduct: "Over Product",
  youMayAlsoLike: "Dit Vindt U Misschien Ook Leuk",

  // Cart
  shoppingCart: "Winkelwagen",
  cartEmpty: "Uw winkelwagen is leeg",
  proceedToCheckout: "Doorgaan naar Afrekenen",
  removeItem: "Verwijderen",
  cartEmptyDesc: "U heeft nog geen producten aan uw winkelwagen toegevoegd. Bezoek onze productpagina om onze heerlijke lekkernijen te ontdekken!",
  itemsInCart: "{count} artikelen in uw winkelwagen",
  cartContents: "Inhoud Winkelwagen",
  clearCart: "Winkelwagen Legen",
  confirmClearCart: "Weet u zeker dat u uw winkelwagen volledig wilt legen?",
  orderSummary: "Bestelling Overzicht",
  calculatingShipping: "Berekenen...",
  shippingCalculatedAtCheckout: "Wordt berekend bij het afrekenen",

  // Checkout
  checkout: "Afrekenen",
  paymentMethod: "Betaalmethode",
  firstName: "Voornaam",
  lastName: "Achternaam",
  city: "Stad",
  postalCode: "Postcode",
  agreeTerms: "Ik ga akkoord met de voorwaarden",
  checkoutSubtitle: "Vul uw gegevens in om uw bestelling af te ronden",
  guestCardOnlyNotice: "Bij bestellingen als gast kan alleen met kaart worden betaald.",
  termsAndConditions: "Algemene Voorwaarden",
  agreeTermsAndPrivacy: "Ik heb de {terms} en het {privacy} gelezen en ga hiermee akkoord.",
  qtyUnit: "stuks",
  backToCart: "Terug naar Winkelwagen",
  sslEncryption: "256-bit SSL-versleuteling",
  enterCityForShipping: "Voer uw stad in",
  orderCreationFailed: "De bestelling kon niet worden aangemaakt.",
  orderCreationError: "Er is een fout opgetreden bij het aanmaken van uw bestelling.",
  checkoutEmptyCartDesc: "U moet eerst producten aan uw winkelwagen toevoegen voordat u kunt afrekenen.",
  downloading: "Downloaden...",
  invoiceDownloadFailed: "De factuur kon niet worden gedownload. Probeer het later opnieuw.",

  // Order
  orderSuccess: "Bestelling Succesvol!",
  orderSuccessMessage: "Uw bestelling is succesvol verwerkt. We sturen u binnenkort bestelgegevens per e-mail.",
  orderDetails: "Bestelgegevens",
  orderNumber: "Bestelnummer",
  date: "Datum",
  status: "Status",
  confirmed: "Bevestigd",
  emailConfirmation: "E-mail Bevestiging",
  emailConfirmationDesc: "Controleer de e-mail met uw bestelgegevens",
  preparing: "Voorbereiden",
  preparingDesc: "Uw producten worden zorgvuldig voorbereid",
  delivery: "Bezorging",
  deliveryDesc: "Verse producten komen naar uw deur",
  trackOrder: "Bestelling Volgen",
  continueShopping: "Verder Winkelen",

  // Order Tracking
  trackYourOrder: "Volg Uw Bestelling",
  enterOrderId: "Voer bestel-ID of trackingnummer in",
  orderNotFound: "Bestelling niet gevonden",
  shippingAddress: "Verzendadres",
  trackingNumber: "Trackingnummer",
  orderItems: "Bestelde Items",
  orderPlaced: "Bestelling Geplaatst",
  processing: "Verwerken",
  shipped: "Verzonden",
  outForDelivery: "Onderweg",
  delivered: "Bezorgd",
  estimatedDelivery: "Geschatte Bezorging",
  downloadInvoice: "Factuur Downloaden",
  packagingStatus: "Wordt Verpakt",
  orderCancelled: "Geannuleerd",
  defaultProductName: "Heerlijke Lekkernij",
  defaultCustomerName: "Beste Klant",
  orderFetchError: "Er is een fout opgetreden bij het ophalen van uw bestelgegevens.",
  awaitingDate: "In afwachting",
  fetchingOrder: "Uw Bestelling Wordt Opgehaald...",
  deliveryJourney: "Bezorgtraject",
  packageTrackingTitle: "Is Uw Pakket {highlight}",
  packageTrackingTitleHighlight: "Veilig?",
  trackOrderInstructions: "Voer uw bestelnummer in het bovenstaande veld in om de status van uw pakket in realtime te bekijken.",
  getSupport: "Ondersteuning",
  backToStore: "Terug naar de Winkel",
  orderHistoryLabel: "Bestelgeschiedenis",
  deliveryInfoTitle: "Bezorggegevens",
  needHelpTitle: "Hulp Nodig?",
  whatsappHelpText: "U kunt ons altijd via WhatsApp bereiken over uw bestelling.",
  customerService: "Klantenservice",
  notSatisfiedTitle: "Niet tevreden met uw product?",
  returnExchangeText: "U kunt een retour- of ruilverzoek indienen.",
  createReturnRequest: "Retourverzoek Aanmaken",

  // Cash on Delivery Options
  deliveryOptionsLoadError: "Er is een fout opgetreden bij het laden van de bezorgopties.",
  loadingDeliveryOptions: "Bezorgopties worden geladen...",
  codTitle: "Rembours & Bezorgopties",
  noDeliveryScheduleForCity: "Er is momenteel geen bezorgschema voor deze stad.",
  tryDifferentMethodOrLater: "Kies een andere bezorgmethode of probeer het later opnieuw.",
  currentMonthLabel: "Huidige Maand",
  codAvailable: "Beschikbaar",
  moreDatesAvailable: "+{count} data meer beschikbaar",
  nextMonthLabel: "Volgende Maand",
  codScheduled: "Gepland",
  currentMonthScheduleCompleted: "Het bezorgschema voor deze maand is voltooid",
  currentMonthPassedNextAvailable: "De geplande bezorgdata voor deze maand zijn verstreken. Bezorging is mogelijk volgende maand.",
  selectedDeliveryDateLabel: "Geselecteerde Bezorgdatum",
  activeDeliverySchedules: "Actieve Bezorgschema's",

  // Payment Methods
  payWithCard: "Betalen met Kaart",
  cashOnDeliveryLabel: "Rembours",
  selectPaymentMethod: "Selecteer Betaalmethode",
  noActivePaymentMethod: "Er is momenteel geen actieve betaalmethode beschikbaar. Neem contact op met de beheerder.",
  paymentProcessingError: "Er is een fout opgetreden tijdens de betaling.",
  pay: "Betalen",
  redirecting: "Doorverwijzen...",
  payWithMethod: "Betalen met {method}",
  paymentAmountLabel: "Betaalbedrag",
  redirectingToPaymentPage: "U wordt doorgestuurd naar de betaalpagina.",
  mollieStartFailed: "De Mollie-betaling kon niet worden gestart.",
  cashOnDeliveryDesc: "U kunt contant of met kaart betalen bij levering.",
  confirmOrder: "Bestelling Bevestigen",
  orderWithPaymentObligation: "Bestelling met betalingsverplichting",
  cardNotStoredDesc: "Voor uw veiligheid worden uw kaartgegevens nooit opgeslagen op onze systemen. Elke bestelling wordt veilig verwerkt via Stripe of Mollie.",
  calculatingDeliveryDates: "Bezorgdata worden berekend...",
  noDeliveryScheduleContact: "Er is nog geen bezorgschema ingesteld voor \"{city}\". Neem contact met ons op.",
  deliveryInfoLabel: "Bezorginformatie",
  deliveryDaysLabel: "Bezorgdagen:",
  upcomingDeliveryDates: "Aankomende Bezorgdata",
  freeShippingOverAmount: "Gratis vanaf {amount}",
  selectCityLabel: "Selecteer Stad",
  cityListLoadFailed: "De lijst met steden kon niet worden geladen",
  paymentVerifying: "Betaling Wordt Geverifieerd",
  paymentVerifyingDesc: "Uw betaling wordt gecontroleerd, een ogenblik geduld...",
  paymentSuccessful: "Betaling Geslaagd!",
  orderReceivedRedirecting: "Uw bestelling is ontvangen, u wordt doorgestuurd...",

  // Reviews
  customerReviews: "Klantbeoordelingen",
  writeReview: "Beoordeling Schrijven",
  rating: "Beoordeling",
  reviewTitle: "Beoordeling Titel",
  yourReview: "Uw Beoordeling",
  yourName: "Uw Naam",
  yourFullName: "Uw Volledige Naam",
  submitReview: "Beoordeling Indienen",
  verified: "Geverifieerd",
  wasHelpful: "Was deze beoordeling nuttig?",
  yes: "Ja",
  no: "Nee",
  noReviewsYet: "Nog geen beoordelingen",
  beFirstToReview: "Wees de eerste om dit product te beoordelen!",
  writeFirstReview: "Eerste Beoordeling Schrijven",

  // Profile
  personalInfo: "Persoonlijke Gegevens",
  profileUpdated: "Profiel succesvol bijgewerkt!",

  // Email Notifications
  emailNotifications: "E-mail Meldingen",
  language: "Taal",
  orderConfirmations: "Bestelling Bevestigingen",
  orderConfirmationsDesc: "Ontvang bevestigings-e-mails wanneer u een bestelling plaatst",
  shippingUpdates: "Verzending Updates",
  shippingUpdatesDesc: "Krijg een melding wanneer uw bestelling wordt verzonden",
  deliveryNotifications: "Bezorging Meldingen",
  deliveryNotificationsDesc: "Ontvang meldingen wanneer uw bestelling wordt bezorgd",
  marketingEmails: "Marketing E-mails",
  marketingEmailsDesc: "Ontvang promotionele e-mails en speciale aanbiedingen",
  newsletter: "Nieuwsbrief",
  newsletterDesc: "Blijf op de hoogte van ons laatste nieuws en producten",
  productRecommendations: "Product Aanbevelingen",
  productRecommendationsDesc: "Krijg gepersonaliseerde productaanbevelingen",
  reviewReminders: "Beoordeling Herinneringen",
  reviewRemindersDesc: "Herinneringen om producten te beoordelen die u heeft gekocht",
  specialOffers: "Speciale Aanbiedingen",
  specialOffersDesc: "Exclusieve aanbiedingen en kortingen",
  birthdayOffers: "Verjaardag Aanbiedingen",
  birthdayOffersDesc: "Speciale aanbiedingen op uw verjaardag",
  emailFrequency: "E-mail Frequentie",
  emailFrequencyDesc: "We respecteren uw inbox en sturen alleen relevante e-mails. U kunt deze instellingen altijd wijzigen.",

  // Wishlist
  wishlist: "Verlanglijst",
  myWishlist: "Mijn Verlanglijst",
  wishlistEmpty: "Uw Verlanglijst is Leeg",
  wishlistEmptyDesc: "U heeft nog geen producten aan uw verlanglijst toegevoegd. Klik op het hartje bij producten die u leuk vindt om ze toe te voegen aan uw verlanglijst.",
  removeFromWishlist: "Verwijderen uit Verlanglijst",
  wishlistItemsCount: "U heeft {count} items in uw verlanglijst",
  addAllToCart: "Alles Toevoegen aan Winkelwagen",
  clearWishlist: "Verlanglijst Wissen",
  clearWishlistConfirm: "Weet u zeker dat u uw verlanglijst wilt wissen?",
  totalValue: "Totale Waarde",
  addedToCart: "toegevoegd aan winkelwagen!",
  allItemsAddedToCart: "Alle items toegevoegd aan winkelwagen!",
  startShopping: "Begin met Winkelen",
  lastUpdatedLabel: "Laatst Bijgewerkt",

  // Coupons
  haveCoupon: "Heeft u een Couponcode?",
  enterCouponCode: "Voer couponcode in",
  apply: "Toepassen",
  couponApplied: "Coupon Toegepast",
  invalidCoupon: "Ongeldige couponcode",
  couponExpired: "Coupon is verlopen",
  minPurchaseNotMet: "Minimum aankoopbedrag niet bereikt",
  couponError: "Coupon fout",
  availableCoupons: "Beschikbare Coupons",
  couponCopied: "Coupon gekopieerd",
  validUntil: "Geldig Tot",
  minPurchase: "Min. Aankoop",
  copy: "Kopiëren",
  freeShipping: "Gratis Verzending",

  // Social Media
  share: "Delen",
  linkCopied: "Link gekopieerd!",
  followUsOn: "Volg ons op",

  // FAQ
  frequentlyAskedQuestions: "Veelgestelde Vragen",
  faqQuestion1: "Hoe kan ik mijn bestelling volgen?",
  faqAnswer1: "U kunt uw bestelling volgen door uw bestelnummer in te voeren op de 'Bestelling Volgen' pagina of door de tracking link te gebruiken die per e-mail is verzonden.",
  faqQuestion2: "Wat is de verzendtijd?",
  faqAnswer2: "Onze verzendtijd naar België en Nederland is 3-5 werkdagen. Voor speciale gevallen kunt u contact opnemen met onze klantenservice.",
  faqQuestion3: "Welke betaalmethoden accepteert u?",
  faqAnswer3: "U kunt betalen met creditcard, bankoverschrijving en PayPal. Alle betalingen worden veilig verwerkt.",
  faqQuestion4: "Wat is het retourbeleid?",
  faqAnswer4: "U kunt contact opnemen met ons ondersteuningsteam binnen 2 dagen na levering van uw producten.",
  faqQuestion5: "Zijn uw producten natuurlijk?",
  faqAnswer5: "Ja, al onze producten worden bereid met natuurlijke ingrediënten. Ze bevatten geen conserveermiddelen of kunstmatige toevoegingen.",
  faqQuestion6: "Hoe kan ik lid worden?",
  faqAnswer6: "U kunt een gratis account aanmaken door op de 'Registreren' knop in de rechterbovenhoek te klikken. U kunt zich eenvoudig registreren met uw e-mailadres en wachtwoord.",
  faqQuestion7: "Zijn uw producten halal gecertificeerd?",
  faqAnswer7: "Ja, al onze producten zijn halal gecertificeerd. We zorgen voor naleving van halal standaarden in onze productieprocessen en worden regelmatig gecontroleerd. We delen graag onze certificaten met onze klanten.",
  faqQuestion8: "Wordt de voedingswaarde van bevroren producten behouden?",
  faqAnswer8: "Ja, we gebruiken snelle vriestechnologie om de voedingswaarde en smaak van onze producten te behouden. Zo krijgt u de smaak alsof het vers bereid is.",
  faqQuestion9: "Bevatten uw producten toevoegingen?",
  faqAnswer9: "Nee, we gebruiken geen kunstmatige toevoegingen in onze producten. Onze producten, bereid met traditionele methoden en natuurlijke ingrediënten, zijn zowel gezond als heerlijk.",

  // About Page
  aboutUs: "Over Ons",
  ourStory: "Ons Verhaal",
  ourStoryText: "Eticaret werd geboren met de visie om de diepgewortelde Turkse culinaire traditie naar de moderne wereld te brengen. Door de recepten van onze grootmoeders, doorgegeven door generaties, te combineren met de hygiënestandaarden en technologische mogelijkheden van vandaag, stellen we iedereen in staat om traditionele smaken thuis te ervaren.",
  ourMissionText: "Ons doel is niet alleen om heerlijke producten aan te bieden, maar ook om de rijkdom van de Turkse cultuur aan de wereld voor te stellen. Elk van onze producten wordt bereid met traditionele methoden, hygiënisch verpakt en geleverd aan iedereen als bevroren producten.",
  halalCertified: "Halal Gecertificeerd",
  ourValues: "Onze Waarden",
  traditionalCraftsmanship: "Traditioneel Vakmanschap",
  traditionalCraftsmanshipText: "Elk van onze producten wordt bereid met jarenlange ervaring en liefde. We presenteren onze traditionele recepten door ze te mengen met moderne technieken.",
  qualityAssurance: "Kwaliteitsgarantie",
  qualityAssuranceText: "We stellen klanttevredenheid voorop met onze producten die zorgvuldig worden gecontroleerd in elke fase met de hoogste kwaliteit materialen.",
  halalCertifiedValue: "Halal Gecertificeerd",
  halalCertifiedValueText: "Al onze producten zijn halal gecertificeerd en we winnen het vertrouwen van onze klanten die religieuze gevoeligheden hebben.",
  followUsText: "U kunt ons laatste nieuws volgen via onze sociale media accounts en op de hoogte blijven van onze nieuwe producten.",
  ourProductionProcess: "Ons Productieproces",
  freezingTechnology: "Vriestechnologie",
  freezingTechnologyText: "We behouden smaak en voedingswaarde met snelle vriestechnologie.",
  qualityAndHygiene: "Kwaliteit en Hygiëne",
  qualityAndHygieneText: "We produceren onder hygiënische omstandigheden volgens Europese normen met de hoogste kwaliteit materialen.",
  globalAccess: "Wereldwijde Toegang",
  globalAccessText: "We leveren Turkse smaken overal ter wereld met bevroren producttechnologie.",
  followUsOnSocialMedia: "Volg Ons op Sociale Media",
  followUsOnSocialMediaText: "Volg de verhalen van onze traditionele smaken, onze productieprocessen en onze speciale campagnes op sociale media!",
  aboutHeroTagline: "Van Traditie naar de Toekomst",
  aboutHeroTitlePrefix: "Het Eeuwenoude",
  aboutHeroTitleHighlight: "Verhaal van Anatolië",
  aboutHeroQuote: "Een duizendjarige erfenis van smaak, gekneed door de rijkdom van de aarde, gerijpt door vuur en door de handen van meesters tot kunst gemaakt.",
  aboutHeritageTitlePrefix: "Duizend Jaar",
  aboutHeritageTitleHighlight: "het Ritme van het Vuur",
  aboutNaturalContentLabel: "Natuurlijke Inhoud",
  aboutTraditionalRecipeLabel: "Traditionele Recepten",
  aboutCraftsmanshipTitle: "Artisanale Precisie, Anatolisch Geduld",
  aboutValuesTitlePrefix: "Wat voor Ons",
  aboutValuesTitleHighlight: "Heilig Is",
  categoryGeneral: "Algemeen",
  categoryOrder: "Bestelling",
  categoryProduct: "Product",
  categoryPayment: "Betaling",
  categoryShipping: "Verzending",
  categoryTechnical: "Technisch",
  categoryComplaint: "Klacht",
  categorySuggestion: "Suggestie",
  priorityLabel: "Prioriteit",
  priorityLow: "Laag",
  priorityMedium: "Gemiddeld",
  priorityHigh: "Hoog",
  priorityUrgent: "Dringend",
  selectSubject: "Selecteer een onderwerp",
  subjectInfo: "Informatie",
  subjectOther: "Anders",
  namePlaceholder: "Uw volledige naam",
  emailPlaceholder: "voorbeeld@email.com",
  phonePlaceholder: "+32 555 123 456",
  messagePlaceholder: "Schrijf hier uw bericht...",
  createSupportTicket: "Ondersteuningsticket Aanmaken",
  ticketCreatedSuccess: "Uw ondersteuningsticket is succesvol aangemaakt! Ticketnummer: {ticketNumber}",
  ticketCreationError: "Er is een fout opgetreden bij het aanmaken van uw ondersteuningsticket. Probeer het opnieuw.",
  socialMedia: "Sociale Media",

  // Contact Page
  contactUs: "Contact",
  contactDescription: "Neem contact met ons op. We beantwoorden graag uw vragen en helpen u.",
  contactForm: "Contactformulier",
  contactFormDescription: "U kunt contact met ons opnemen door het onderstaande formulier in te vullen. We nemen zo snel mogelijk contact met u op.",
  subject: "Onderwerp",
  yourMessage: "Uw Bericht",
  country: "Land",
  address: "Adres",
  phone: "Telefoon",
  email: "E-mail",

  // Support Page
  customerSupport: "Klantenservice",
  supportDescription: "Hoe kunnen we u helpen? We zijn er om uw vragen te beantwoorden en uw problemen op te lossen.",
  needMoreHelp: "Heeft u meer hulp nodig?",
  contactUsDirectly: "Neem direct contact met ons op",
  emailSupportDesc: "Antwoord binnen 24 uur",
  sendEmail: "E-mail Versturen",
  whatsappSupport: "WhatsApp Ondersteuning",
  whatsappSupportDesc: "Snel berichten sturen",
  whatsappGreetingMessage: "Hallo! Ik zou graag ondersteuning willen.",
  messageWhatsApp: "Bericht op WhatsApp",

  // Live Support
  online: "Online",
  offline: "Offline",

  // Footer
  followUs: "Volg Ons",
  quickLinks: "Snelle Links",
  categories: "Categorieën",
  desserts: "Desserts",
  contactInfo: "Contactgegevens",
  allRightsReserved: "Alle rechten voorbehouden.",
  privacyPolicy: "Privacybeleid",
  paymentMethods: "Betaalmethoden",
  workingHours: "Openingstijden",

  // Footer Newsletter & Trust
  worldOfPrivileges: "Wereld van Privileges",
  newsletterTitleLine1: "Wees de Eerste die",
  newsletterTitleHighlight: "Paleissmaken Ontdekt",
  newsletterDescriptionFooter: "Wees als eerste op de hoogte van onze nieuwe producten, beperkte oplages en aanbiedingen exclusief voor onze abonnees.",
  subscribe: "Abonneren",
  unsubscribeNote: "* U kunt zich op elk moment uitschrijven.",
  footerBrandDescription: "We combineren de duizendjarige tradities van Anatolië met de meest verse ingrediënten en brengen ze met een moderne presentatie naar uw tafel. We bedienen u met een boetiek productieaanpak die nooit inboet aan kwaliteit.",
  footerFavoriteFlavors: "Favoriete Smaken",
  footerCategoryDesserts: "Desserts & Taarten",
  footerCategoryPastries: "Deegwaren & Börek",
  footerCategoryMains: "Traditionele Gerechten",
  footerCategoryIceCream: "IJs & Koude Desserts",
  footerCategoryGrocery: "Kruidenierswaren & Granen",
  headOffice: "Hoofdkantoor",
  customerLine: "Klantenlijn",
  naturalContentTrustDesc: "Onze producten bevatten geen conserveermiddelen, kunstmatige kleurstoffen of maissiroop.",
  coldChainDelivery: "Koelketen Bezorging",
  coldChainDeliveryDesc: "Met ons speciale verpakkingssysteem leveren we verse producten binnen 48 uur overal in België.",
  securePaymentInfrastructure: "Veilige Betaalinfrastructuur",
  securePaymentInfrastructureDesc: "Al uw betalingen zijn beschermd met 256-bit SSL, ondersteund door Stripe en Bancontact.",
  distanceSalesAgreement: "Overeenkomst op Afstand",

  // Hero Banner
  heroDefaultTitle: "Turkse Keuken",
  heroDefaultSubtitle: "Traditionele Turkse Smaken",
  heroDefaultDescription: "Paleissmaken, gemaakt door meesterhanden met 100% natuurlijke ingrediënten, nu aan uw deur.",
  heroDefaultButtonText: "Ontdek Nu",
  heroDefaultBadge: "Speciale Selectie",
  heroLoadingText: "De Paleiskeuken wordt Voorbereid...",

  // Home Page (main hero & sections)
  homeSeoTitle: "Eticaret — Traditionele Turkse Smaken",
  homeSeoDescription: "Geleverd in België: baklava, börek, manti, ijs en meer. Vers, bevroren, aan uw deur.",
  homeHeroFreeShippingBadge: "Gratis Levering in België — Boven €50",
  homeHeroTitleLine1: "De Verste",
  homeHeroTitleHighlight: "Smaken",
  homeHeroTitleSuffix: "van Anatolië",
  homeHeroDescription: "Baklava, börek, manti, ijs — bevroren en vers. Rechtstreeks naar huis.",
  promoFreeShippingOver50: "Gratis Verzending Boven €50",
  promoFrozenFreshDelivery: "Bevroren — Vers Geleverd",
  promoNaturalIngredient: "Natuurlijke Ingrediënten",
  promoSecurePayment: "Veilig Betalen",
  featuredProductsTitle: "Uitgelichte Producten",
  viewAll: "Alles Bekijken",
  campaignsTitle: "Aanbiedingen",
  campaignsBadge: "Beperkte Tijd",
  campaignsSubtitle: "Korting op geselecteerde producten",
  viewAllCampaigns: "Alle Aanbiedingen Bekijken",
  campaignsSaving: "besparing",
  campaignsEmpty: "Er zijn momenteel geen actieve pakketaanbiedingen.",
  collectionLabel: "Collectie",
  whyEticaret: "Waarom Eticaret?",
  whyEticaretSubtitle: "Wij bieden u het beste",
  whyFrozenFreshTitle: "Vers Ingevroren",
  whyFrozenFreshDesc: "Onze producten worden bereid met de versste recepten en direct bevroren, zodat smaak en voedingswaarde volledig behouden blijven. Het vriezen stopt het microbieel groeiproces, waardoor uw producten langer vers blijven.",
  whyBelgiumWideTitle: "Heel België",
  whyBelgiumWideDesc: "Gratis levering over heel België bij bestellingen boven €50. Ons snelle en veilige logistieke netwerk zorgt ervoor dat uw bestelling snel en veilig bij u thuis aankomt. Elke verzending is volgbaar en in de gaten te houden.",
  whyAllNaturalTitle: "100% Natuurlijk",
  whyAllNaturalDesc: "Alle onze producten worden bereid met natuurlijke ingrediënten, zonder toevoegingen, kleurstoffen of kunstmatige zoetstoffen. Volgens traditionele recepten brengen we u zuivere, authentieke smaken - net zoals zelfgemaakt eten.",
  whySecurePaymentTitle: "Veilig Betalen",
  whySecurePaymentDesc: "Uw transacties zijn volledig versleuteld met betrouwbare betaalplatforms zoals Stripe, Mollie en Bancontact. Kies voor cash bij levering om uw bestelling te inspecteren voordat u betaalt. Privacy en veiligheid zijn onzeabsolute prioriteiten.",
  ctaDiscoverAllProducts: "Ontdek Alle Producten",
  ctaProductCountDesc: "31 traditionele producten, geleverd aan uw deur",

  // Common
  loading: "Laden...",
  connectionRestored: "Verbinding hersteld!",
  noInternetConnection: "Geen internetverbinding",
  cartTooltip: "Mijn Winkelwagen ({count} artikelen)",
  skipToMainContent: "Naar hoofdinhoud",
  error: "Fout",
  success: "Succes",
  discountAmount: "Korting",
  cancel: "Annuleren",
  save: "Opslaan",
  edit: "Bewerken",
  add: "Toevoegen",
  view: "Bekijken",
  submit: "Indienen",
  total: "Totaal",
  subtotal: "Subtotaal",
  tax: "Belasting",
  shipping: "Verzending",
  discount: "Korting",
  free: "Gratis",

  // Inventory Management
  overview: "Overzicht",
  alerts: "Waarschuwingen",
  outOfStock: "Uitverkocht",
  inStock: "Op Voorraad",
  product: "Product",
  minStock: "Min. Voorraad",

  // Search & Filters
  searchPlaceholder: "Zoek producten...",
  suggestions: "Suggesties",
  recentSearches: "Recente Zoekopdrachten",
  filters: "Filters",
  category: "Categorie",
  subcategory: "Subcategorie",
  allSubcategories: "Alle Subcategorieën",
  priceRange: "Prijsklasse",
  newProducts: "Nieuwe Producten",
  recommendedForYou: "Aanbevolen Voor U",
  popular: "Populair",
  onSale: "In de Aanbieding",
  brand: "Merk",
  origin: "Herkomst",
  sortBy: "Sorteren Op",
  relevance: "Relevantie",
  priceLow: "Prijs (Laag-Hoog)",
  priceHigh: "Prijs (Hoog-Laag)",
  newest: "Nieuwste",
  name: "Naam",
  searching: "Zoeken",
  showAllProducts: "Alle Producten Tonen",
  unknown: "Onbekend",

  // Admin Dashboard
  orders: "Bestellingen",
  customers: "Klanten",
  reports: "Rapporten",
  settings: "Instellingen",
  totalOrders: "Totaal Bestellingen",
  totalRevenue: "Totale Omzet",
  totalCustomers: "Totaal Klanten",

  // Analytics & Reporting
  analyticsDashboard: "Analyse Dashboard",
  businessOverview: "Bedrijfsoverzicht",
  salesAnalytics: "Verkoopanalyse",
  customerAnalytics: "Klantanalyse",
  inventoryAnalytics: "Voorraadanalyse",
  marketingAnalytics: "Marketinganalyse",
  reportsAndExports: "Rapporten en Exports",
  last7Days: "Laatste 7 Dagen",
  last30Days: "Laatste 30 Dagen",
  last90Days: "Laatste 90 Dagen",
  lastYear: "Vorig Jaar",
  dateRange: "Datumbereik",
  vsLastMonth: "t.o.v. Vorige Maand",
  averageOrderValue: "Gemiddelde Bestelwaarde",
  conversionRate: "Conversieratio",
  newCustomers: "Nieuwe Klanten",
  averageCustomerValue: "Gemiddelde Klantwaarde",
  turnoverRate: "Omloopsnelheid",
  averageStockDays: "Gemiddelde Voorraaddagen",
  totalVisitors: "Totaal Bezoekers",
  uniqueVisitors: "Unieke Bezoekers",
  bounceRate: "Bouncepercentage",
  avgSessionDuration: "Gem. Sessieduur",
  revenueTrend: "Omzettrend",
  revenueByCategory: "Omzet per Categorie",
  customerSegments: "Klantsegmenten",
  trafficSources: "Verkeersbronnen",
  conversionFunnel: "Conversietrechter",
  topMovingProducts: "Best Verkopende Producten",
  unitsSold: "Verkochte Eenheden",
  generateReport: "Rapport Genereren",
  exportData: "Gegevens Exporteren",
  reportType: "Rapporttype",
  salesReport: "Verkooprapport",
  customerReport: "Klantrapport",
  inventoryReport: "Voorraadrapport",
  marketingReport: "Marketingrapport",
  comprehensiveReport: "Uitgebreid Rapport",
  generatePDF: "PDF Genereren",
  generateExcel: "Excel Genereren",
  exportSalesData: "Verkoopgegevens Exporteren",
  exportCustomerData: "Klantgegevens Exporteren",
  exportInventoryData: "Voorraadgegevens Exporteren",
  exportMarketingData: "Marketinggegevens Exporteren",

  // Navigation
  confirmLogout: "Weet je zeker dat je wilt uitloggen?",
  collections: "Collecties",
  collectionsMenuTitleLine1: "Bijzondere Ontdekkingen",
  collectionsMenuTitleHighlight: "Uit Anatolië",
  collectionsMenuSubtitle: "Traditionele Recepten, Moderne Presentaties",
  viewAllCollections: "Bekijk Alle Collecties",
  discover: "Ontdek",
  sustainableShipping: "Duurzame Verzending",
  allNaturalContent: "100% Natuurlijke Inhoud",
  allCategoryProducts: "Alle {category} Producten",
  logoAlt: "Logo",
  cookiePolicy: "Cookiebeleid",
  termsOfUse: "Gebruiksvoorwaarden",
  cookieUsageTitle: "Cookiegebruik",
  cookieUsageDescPrefix: "Door onze site te gebruiken, gebruiken we cookies om de prestaties van onze website te verbeteren en u een betere service te bieden. Lees voor meer details ons",
  cookieUsageDescSuffix: ".",
  onlyNecessary: "Alleen Noodzakelijk",
  acceptAll: "Alles Accepteren",
  cookiePreferencesTitle: "Cookievoorkeuren",
  cookiePreferencesDesc: "U kunt kiezen welke cookies u wilt accepteren",
  necessaryCookiesTitle: "Noodzakelijke Cookies",
  alwaysActive: "Altijd actief",
  necessaryCookiesDesc: "Vereist voor de basisfuncties van de website. Deze kunnen niet worden uitgeschakeld.",
  performanceCookiesTitle: "Prestatiecookies",
  performanceCookiesDesc: "Gebruikt om de websiteprestaties en gebruikerservaring te analyseren.",
  examplesLabel: "Voorbeelden",
  functionalCookiesTitle: "Functionele Cookies",
  functionalCookiesDesc: "Gebruikt om uw voorkeuren te onthouden en een gepersonaliseerde ervaring te bieden.",
  functionalCookiesExamples: "Taalvoorkeuren, regio-instellingen",
  marketingCookiesTitle: "Marketingcookies",
  marketingCookiesDesc: "Gebruikt om relevantere advertenties te tonen en voor marketinganalyse.",
  saveMyPreferences: "Mijn Voorkeuren Opslaan",
  
  // Email Verification
  emailVerification: "E-mail Verificatie",
  emailVerificationRequired: "E-mail Verificatie Vereist",
  emailVerificationMessage: "Klik op de verificatielink die naar {email} is gestuurd om uw e-mailadres te verifiëren.",
  emailVerifiedSuccessfully: "E-mail Succesvol Geverifieerd",
  emailVerifiedMessage: "Uw e-mailadres is succesvol geverifieerd. U kunt nu van alle functies genieten.",
  emailVerificationFailed: "E-mail Verificatie Mislukt",
  emailVerificationFailedMessage: "E-mail verificatie is mislukt. Probeer het opnieuw.",
  checkYourEmail: "Controleer Uw E-mail",
  emailVerificationInstructions: "Klik op de verificatielink die naar uw e-mailadres is gestuurd om uw account te verifiëren.",
  resendVerificationEmail: "Verificatie E-mail Opnieuw Verzenden",
  resendVerificationDescription: "Vul het onderstaande formulier in om een verificatie e-mail naar uw e-mailadres te sturen.",
  sendVerificationEmail: "Verificatie E-mail Verzenden",
  verifyingEmail: "E-mail verifiëren...",
  verificationStatusCheckFailed: "De e-mailverificatiestatus kon niet worden gecontroleerd",
  verificationEmailSent: "Verificatie-e-mail verzonden",
  verificationEmailSendFailed: "De e-mail kon niet worden verzonden",
  pleaseWaitSeconds: "Wacht {seconds} seconden",
  continueToProfile: "Doorgaan naar Profiel",
  backToProfile: "Terug naar Profiel",
  backToHome: "Terug naar Home",
  resendIn: "Opnieuw verzenden over",
  sending: "Verzenden...",
  dismiss: "Sluiten",
  needHelp: "Hulp Nodig?",
  didntReceiveEmail: "E-mail niet ontvangen?",
  checkSpamFolder: "Controleer uw spam map en zorg ervoor dat de e-mail niet als spam is gemarkeerd.",
  wrongEmailAddress: "Verkeerd e-mailadres?",
  contactSupportMessage: "Neem contact op met ons ondersteuningsteam.",
  verificationLinkExpired: "Verificatielink verlopen?",
  requestNewVerification: "Vraag een nieuwe verificatie e-mail aan.",
  pleaseEnterEmail: "Voer uw e-mailadres in.",
  emailAddress: "E-mailadres",
  enterEmailAddress: "Voer uw e-mailadres in",

  // Products Page
  anatolianCollectionLabel: "Anatolische Collectie",
  listedProducts: "Weergegeven",
  noResultsTitle: "Hier Hebben We Niets Voor U",
  noResultsDescription: "We konden geen producten vinden die aan uw criteria voldoen. Wis de filters en probeer het opnieuw.",

  // Product Card
  newLabel: "Nieuw",
  addingToCart: "Toevoegen...",
  quickAdd: "SNEL TOEVOEGEN",

  // Product Detail
  productNotFound: "Product Niet Gevonden",
  productNotFoundDesc: "Het product dat u zoekt bestaat niet of is verwijderd.",
  backToProducts: "Terug naar Producten",
  selectionRequired: "* Selecteer",
  lastUnitsLeft: "(Nog {count} stuks)",
  selectVariant: "Selecteer een Variant",
  readReturnPolicy: "U kunt hier ons retourbeleid lezen",
  codPaymentNote: "Betalen bij levering kan mogelijk zijn; definitieve bevestiging hangt af van uw adres bij het afrekenen.",
  selectCityForDelivery: "Selecteer hierboven uw stad om leverdagen en de beschikbaarheid van betalen bij levering te zien.",
  productCode: "Productcode",
  nutritionalValues: "Voedingswaarden",

  // Product Filters
  filterOptionsHeading: "Opties",
  reset: "Reset",
  allPrefix: "ALLE",
  preferences: "Voorkeuren",
  doesNotContainSuffix: "VRIJ",
  traditionalMethodsLine1: "Bereid volgens traditionele methoden,",
  traditionalMethodsLine2: "met zorg gemaakt.",

  // Product Gallery
  clickToCloseZoom: "Klik om zoom te sluiten",
  zoomOut: "Uitzoomen",
  zoomIn: "Inzoomen",

  // Product Reviews
  fillRequiredFields: "Vul alle verplichte velden in.",
  reviewSubmittedPendingApproval: "Uw beoordeling is ingediend ter beoordeling en wordt gepubliceerd zodra deze is goedgekeurd.",
  reviewSubmitFailed: "Uw beoordeling kon niet worden verzonden. Probeer het opnieuw.",
  outOf5: "van 5",
  basedOnReviews: "Gebaseerd op {count} beoordelingen",
  summarizeExperience: "Vat uw ervaring samen",
  tellUsExperience: "Vertel ons over uw ervaring met dit product",

  // Login Page
  welcomeBack: "Welkom Terug",
  loginSubtitle: "Log in op uw account",
  exampleEmailPlaceholder: "voorbeeld@email.com",
  password: "Wachtwoord",
  enterPasswordPlaceholder: "Voer uw wachtwoord in",
  rememberMe: "Onthoud mij",
  forgotPasswordLink: "Wachtwoord vergeten?",
  loggingIn: "Bezig met inloggen...",
  or: "of",
  continueWithGoogle: "Inloggen met Google",
  dontHaveAccount: "Heeft u nog geen account?",
  signUpNow: "Registreer nu",
  loginErrorGeneric: "Er is een fout opgetreden tijdens het inloggen!",

  // Register Page
  registerSubtitle: "Word lid van de Turkse Keuken familie",
  firstNameRequired: "Voornaam is verplicht",
  lastNameRequired: "Achternaam is verplicht",
  emailRequired: "E-mailadres is verplicht",
  invalidEmail: "Voer een geldig e-mailadres in",
  passwordRequired: "Wachtwoord is verplicht",
  passwordMinLength: "Wachtwoord moet minstens 6 tekens bevatten",
  passwordsDoNotMatch: "Wachtwoorden komen niet overeen",
  cityRequired: "Stad selecteren is verplicht",
  agreeTermsRequired: "U moet de voorwaarden accepteren",
  registerErrorGeneric: "Er is een fout opgetreden tijdens het registreren!",
  firstNamePlaceholder: "Uw voornaam",
  lastNamePlaceholder: "Uw achternaam",
  phonePlaceholderExample: "0455 12 34 56",
  cityDeliveryHelperText: "Nodig om de beschikbaarheid van rembours en leverdagen te kunnen tonen.",
  passwordMinCharsPlaceholder: "Minstens 6 tekens",
  confirmPassword: "Wachtwoord Bevestigen",
  confirmPasswordPlaceholder: "Voer uw wachtwoord opnieuw in",
  wantMarketingEmails: "Ik wil graag e-mails ontvangen over acties en nieuwe producten.",
  registering: "Bezig met registreren...",
  registerWithGoogle: "Registreren met Google",
  alreadyHaveAccount: "Heeft u al een account?",
  loginNow: "Log in",

  // Forgot / Reset Password
  forgotPasswordTitle: "Wachtwoord Vergeten",
  forgotPasswordDescription: "Voer uw e-mailadres in en we sturen u een resetlink.",
  resetLinkSentDefault: "Resetlink verzonden.",
  genericErrorRetry: "Er is een fout opgetreden. Probeer het opnieuw.",
  checkSpamReminder: "Vergeet niet ook uw spammap te controleren.",
  sendResetLink: "Resetlink Versturen",
  backToLoginLink: "Terug naar Inloggen",
  invalidLinkTitle: "Ongeldige Link",
  invalidLinkDesc: "De link voor het opnieuw instellen van uw wachtwoord ontbreekt of is ongeldig.",
  requestNewLink: "Nieuwe link aanvragen",
  setNewPasswordTitle: "Nieuw Wachtwoord Instellen",
  minCharsHint: "Gebruik minstens 6 tekens.",
  passwordResetSuccessDefault: "Uw wachtwoord is succesvol opnieuw ingesteld.",
  invalidOrExpiredLink: "Ongeldige of verlopen link.",
  redirectingToLogin: "U wordt doorgestuurd naar de inlogpagina...",
  newPassword: "Nieuw Wachtwoord",
  saving: "Bezig met opslaan...",
  resetPasswordButton: "Wachtwoord Resetten",

  // OAuth Callback
  invalidLoginLink: "De inloglink is ongeldig.",
  loginFailedGeneric: "Inloggen mislukt.",
  loggingInEllipsis: "Bezig met inloggen…",

  // Profile Page
  myProfile: "Mijn Profiel",
  manageAccountInfo: "Beheer uw accountgegevens",
  myOrders: "Mijn Bestellingen",
  security: "Beveiliging",
  memberSince: "Lid sinds",
  favoriteProducts: "Favoriete Producten",
  averageRating: "Gemiddelde Beoordeling",
  itemsCountSuffix: "producten",
  details: "Details",
  noOrdersYet: "U heeft nog geen bestellingen geplaatst",
  discoverProductsForFirstOrder: "Ontdek onze producten om uw eerste bestelling te plaatsen",
  myFavoriteProducts: "Mijn Favoriete Producten",
  noFavoritesYet: "U heeft nog geen favoriete producten",
  addFavoritesHint: "Voeg producten die u leuk vindt toe aan uw favorieten",
  exploreProducts: "Producten Ontdekken",
  securitySettings: "Beveiligingsinstellingen",
  changePassword: "Wachtwoord Wijzigen",
  lastPasswordChange: "Laatst gewijzigd: 3 maanden geleden",
  changeAction: "Wijzigen",
  twoFactorAuth: "Tweestapsverificatie",
  twoFactorAuthDesc: "Maak uw account veiliger",
  enableAction: "Inschakelen",
  sessionHistory: "Sessiegeschiedenis",
  sessionHistoryDesc: "Bekijk uw actieve sessies",
  profileUpdateError: "Er is een fout opgetreden bij het bijwerken van uw profiel. Probeer het opnieuw.",
  orderStatusPending: "in afwachting",
  orderStatusConfirmed: "bevestigd",
  orderStatusProcessing: "wordt voorbereid",
  orderStatusShipped: "verzonden",
  orderStatusDelivered: "afgeleverd",
  orderStatusCancelled: "geannuleerd",
  orderStatusRefunded: "terugbetaald",
  orderStatusNotification: "Uw bestelling {orderNumber}: {status}",

  // Email Notification Settings
  loadPreferencesError: "Er is een fout opgetreden bij het laden van uw meldingsvoorkeuren",
  userNotFound: "Gebruikersgegevens niet gevonden",
  saveSettingsError: "Er is een fout opgetreden bij het bijwerken van de instellingen",
  emailSettingsUpdated: "E-mailinstellingen succesvol bijgewerkt!",
  selectEmailsToReceive: "Kies welke e-mails u wilt ontvangen",
  currentFrequencyLabel: "Huidige frequentie:",
  weeklyEmailLimitText: "Maximaal 2-3 e-mails per week",

  // Natural Ingredients Page
  naturalIngredientsTitle: "🌿 Natuurlijke Ingrediënten",
  naturalIngredientsIntro: "Wij bereiden onze producten uitsluitend met de beste, natuurlijke en verse ingrediënten. Geen conserveringsmiddelen, kunstmatige zoetstoffen of toevoegingen.",
  naturalIngredients100Title: "100% Natuurlijke Ingrediënten",
  naturalIngredientsDesc1: "Als Turkse Keuken gebruiken wij uitsluitend natuurlijke en biologische ingrediënten in onze producten. We behouden onze traditionele recepten en passen tegelijk moderne hygiënenormen toe.",
  naturalIngredientsListIntro: "De ingrediënten die we in elk product gebruiken:",
  ingredientHoney: "Natuurlijke honingsoorten",
  ingredientWalnut: "Biologische walnoten en pistachenoten",
  ingredientFlour: "Traditionele meelsoorten",
  ingredientAroma: "Natuurlijke aroma's en kruiden",
  ingredientSugar: "Biologische suiker en zoetstoffen",
  naturalHoneyTitle: "Natuurlijke Honing",
  naturalHoneyDesc: "Onze natuurlijke honingsoorten, geselecteerd uit de beste honing van Anatolië",
  organicWalnutTitle: "Biologische Walnoten",
  organicWalnutDesc: "Traditionele smaken met onze verse walnoten en pistachenoten",
  traditionalFlourTitle: "Traditioneel Meel",
  traditionalFlourDesc: "Onze meelsoorten geproduceerd met traditionele methoden",
  qualityCertificatesTitle: "Onze Kwaliteitscertificaten",
  halalCertTitle: "Halal Certificaat",
  halalCertDesc: "Al onze producten zijn halal gecertificeerd",
  organicCertTitle: "Biologisch Certificaat",
  organicCertDesc: "Onze ingrediënten zijn biologisch gecertificeerd",
  discoverNaturalIngredientsTitle: "Ontdek Onze Natuurlijke Ingrediënten",
  discoverNaturalIngredientsDesc: "Bekijk onze producten gemaakt met natuurlijke ingrediënten en plaats uw bestelling",
  reviewOurProducts: "Bekijk Onze Producten",

  // Master Hands Page
  masterHandsTitle: "👩‍🍳 Meesterhanden",
  masterHandsIntro: "Elk van onze producten wordt bereid met jarenlange ervaring en liefde. We combineren onze traditionele recepten met moderne technieken.",
  traditionalRecipesTitle: "Traditionele Recepten",
  masterHandsDesc1: "We bieden onze traditionele recepten, doorgegeven door onze grootouders, gecombineerd met moderne hygiënenormen.",
  masterHandsListIntro: "De kenmerken van onze meesterhanden:",
  masterHandsFeature1: "Ervaring van 3 generaties",
  masterHandsFeature2: "Behoud van traditionele recepten",
  masterHandsFeature3: "Moderne hygiënenormen",
  masterHandsFeature4: "Familiewarmte in elk product",
  masterHandsFeature5: "Nauwgezette kwaliteitscontrole",
  masterMehmetName: "Meester Mehmet",
  masterMehmetDesc: "30 jaar ervaring, traditionele baklavameester",
  masterFatmaName: "Mevrouw Fatma",
  masterFatmaDesc: "Helva- en sucukexpert, 25 jaar ervaring",
  masterAliName: "Meester Ali",
  masterAliDesc: "Honingexpert, 20 jaar imkerervaring",
  productionProcessTitle: "Ons Productieproces",
  processStep1Title: "Ingrediëntenselectie",
  processStep1Desc: "We selecteren de beste ingrediënten",
  processStep2Title: "Traditioneel Recept",
  processStep2Desc: "We passen de recepten van onze voorouders toe",
  processStep3Title: "Meesterhanden",
  processStep3Desc: "Onze ervaren meesters bereiden het",
  processStep4Title: "Kwaliteitscontrole",
  processStep4Desc: "We onderwerpen elk product aan kwaliteitscontrole",
  discoverMasterHandsTitle: "Ontdek het Werk van Onze Meesterhanden",
  discoverMasterHandsDesc: "Bekijk onze producten gemaakt met traditionele recepten en plaats uw bestelling",

  // Fast Delivery Page
  fastDeliveryTitle: "🚚 Snelle Levering",
  fastDeliveryIntro: "Wij bezorgen uw verse producten zo snel mogelijk aan uw deur. Wij bieden speciale verpakking en een veilige leveringsgarantie.",
  fastSecureDeliveryTitle: "Snelle en Veilige Levering",
  fastDeliveryDesc1: "Wij leveren uw bestellingen zo snel mogelijk aan uw deur. Onze verse producten worden veilig vervoerd in speciale verpakking.",
  fastDeliveryListIntro: "Onze bezorgkenmerken:",
  deliveryFeature1: "Levering binnen 24 uur",
  deliveryFeature2: "Speciale koelketenverpakking",
  deliveryFeature3: "Veilige verpakking",
  deliveryFeature4: "Optie voor betaling bij levering",
  deliveryFeature5: "Gratis verzending (boven 150 TL)",
  fastDeliveryCardTitle: "Snelle Levering",
  fastDeliveryCardDesc: "Leveringsgarantie binnen 24 uur",
  specialPackagingTitle: "Speciale Verpakking",
  specialPackagingDesc: "Veilige verpakking met koelketen",
  secureDeliveryTitle: "Veilige Levering",
  secureDeliveryDesc: "Betaling bij levering en veilige bezorging",
  deliveryProcessTitle: "Ons Bezorgproces",
  deliveryStep1Title: "Bestelling Ontvangen",
  deliveryStep1Desc: "Wij ontvangen uw bestelling",
  deliveryStep2Title: "Voorbereiding",
  deliveryStep2Desc: "Wij bereiden de verse producten voor",
  deliveryStep3Title: "Verpakking",
  deliveryStep3Desc: "Wij verpakken ze in speciale verpakking",
  deliveryStep4Title: "Levering",
  deliveryStep4Desc: "Wij bezorgen aan uw deur",
  deliveryAreasTitle: "Onze Bezorggebieden",
  deliveryFeesTitle: "Bezorgkosten",
  deliveryFeeOver50: "Bestellingen boven €50:",
  deliveryFeeFree: "GRATIS",
  deliveryFeeUnder50: "Bestellingen onder €50:",
  deliveryFeeFast: "Snelle levering (12 uur):",
  orderNowWithFastDelivery: "Bestel Nu met Snelle Levering",
  orderNowWithFastDeliveryDesc: "Wij bezorgen uw verse producten met snelle levering aan uw deur",
  orderNowButton: "Bestel Nu",

  // Return Request Page
  reasonDamaged: "Beschadigd / Defect Product",
  reasonWrongItem: "Verkeerd Product Verzonden",
  reasonNotAsDescribed: "Komt Niet Overeen met Beschrijving",
  reasonChangedMind: "Van Gedachten Veranderd",
  orderNotFoundPeriod: "Bestelling niet gevonden.",
  orderNotFoundForNumber: "Er is geen bestelling gevonden met dit bestelnummer.",
  returnRequestSubmitError: "Het verzoek kon niet worden verzonden. Probeer het opnieuw.",
  returnRequestReceivedTitle: "Uw Retourverzoek Is Ontvangen",
  returnRequestReceivedDesc: "Uw verzoek wordt beoordeeld. U wordt zo snel mogelijk per e-mail op de hoogte gebracht.",
  trackTheOrder: "Bestelling Volgen",
  returnRequestPageDesc: "U kunt een retourverzoek indienen voor uw bezorgde bestellingen.",
  orderInfoTitle: "Bestelinformatie",
  orderNumberLabel: "Bestelnummer",
  orderNumberPlaceholder: "Bijv: 1234567890",
  findOrderButton: "Bestelling Zoeken",
  orderAmountLabel: "Bedrag",
  returnDeliveredOnlyNotice: "Een retourverzoek kan alleen worden aangemaakt voor bezorgde bestellingen.",
  returnReasonTitle: "Retourreden",
  returnDescriptionLabel: "Beschrijving",
  optionalFieldLabel: "(optioneel)",
  returnDescriptionPlaceholder: "Deel aanvullende informatie over uw retour...",
  submitReturnRequest: "Retourverzoek Versturen",

  // 3D Flipbook Gourmet Brochure
  flipbookSectionBadge: "INTERACTIEVE PROEVERIJ",
  flipbookSectionTitle: "Anatolische Proeverij Brochure",
  flipbookSectionSubtitle: "Sla de pagina's om en ontdek ambachtelijke selecties en exclusieve kortingsbonnen.",
  flipbookTabCover: "📖 Omslag",
  flipbookCoverBadge: "SPECIALE SELECTIE 2026",
  flipbookCoverTitle: "Anatolische Lekkernijen",
  flipbookCoverSubtitle: "Traditionele Meestercatalogus & Speciale Aanbiedingen",
  flipbookCoverDescription: "Eeuwenoude recepten, stenen molens en koperen ketels die gastronomisch erfgoed naar uw tafel brengen.",
  flipbookCoverTagline: "📖 Sla de pagina om en ontdek authentieke smaken uit Anatolië",
  flipbookCoverCouponTitle: "Cataloguskorting",
  flipbookCoverCouponDiscount: "15% Welkomstkorting",
  flipbookOpenCatalog: "Catalogus Openen",
  flipbookTurnPage: "Omslaan ❯",
  flipbookPrevPage: "Vorige Pagina",
  flipbookNextPage: "Volgende Pagina",
  flipbookPageCount: "Pagina",
  flipbookAutoPlayActive: "⏱️ Automatisch Bladeren",
  flipbookAutoPlayPaused: "⏸️ Gepauzeerd (Aanwijzen)",
  flipbookPause: "Pauzeren",
  flipbookPlay: "Afspelen",
  flipbookLimitedOffer: "🔥 Deze aanbieding is tijdelijk geldig.",
  flipbookInspectAndBuy: "Bekijken & Bestellen",
  flipbookTastingPortion: "Proefportie / Speciale Geschenkdoos",
  flipbookNextPageHint: "Sla om naar de volgende pagina ❯",
  flipbookCatalogTitleFooter: "Catalogus Anatolische Lekkernijen",

  // Flipbook Voorbeeld Inhoud
  flipbookCatDesserts: "Traditionele Desserts",
  flipbookTagStar: "Ster van de Dag",
  flipbookBaklavaTitle: "Wortelslice & Antep Pistache Baklava",
  flipbookBaklavaSubtitle: "Gaziantep Smaragd Pistaches & Zuivere Geklaarde Boter",
  flipbookBaklavaStory: "40 flinterdunne handgerolde deeglagen gebakken op eikenhoutvuur. Een knapperige symfonie bij elke hap.",
  flipbookBaklavaFeat1: "100% Natuurlijke Bietsuiker",
  flipbookBaklavaFeat2: "Traditionele Urfa Geklaarde Boter",
  flipbookBaklavaFeat3: "Dagelijks Vers Bereid",

  flipbookCatDeli: "Ontbijt & Delicatessen",
  flipbookTagArtisan: "Ambachtelijke Keuze",
  flipbookCheeseTitle: "Gerijpte Kars Kashar & Gourmet Kazen",
  flipbookCheeseSubtitle: "Van 2400m Hooggelegen Weiden naar Uw Tafel",
  flipbookCheeseStory: "Uitsluitend gemaakt van zomermelk van vrij grazende koeien, 12 maanden natuurlijk gerijpt in grotten.",
  flipbookCheeseFeat1: "12 Maanden Natuurlijke Rijping",
  flipbookCheeseFeat2: "Zonder Toevoegingen of Conserveermiddelen",
  flipbookCheeseFeat3: "Gekoelde Expresslevering",

  flipbookCatNatural: "Natuurlijk & Gezond",
  flipbookTagPure: "Puur Erfgoed",
  flipbookOilHoneyTitle: "Wilde Honing & Koudgeperste Olijfolie",
  flipbookOilHoneySubtitle: "De Zuiverste Natuurlijke Remedies in Eén Pakket",
  flipbookOilHoneyStory: "Vroege oogst koudgeperste olijfolie van de berg Ida gecombineerd met pure wilde honing uit de hooglanden.",
  flipbookOilHoneyFeat1: "Zuurgraad < 0.3%",
  flipbookOilHoneyFeat2: "In Laboratorium Geteste Rauwe Honing",
  flipbookOilHoneyFeat3: "Beschermende Houten Geschenkdoos",

  flipbookCatTreats: "Speciale Lekkernijen",
  flipbookTagPalace: "Paleistraditie",
  flipbookLokumTitle: "Dubbel Geroosterde Pistache Turks Fruit",
  flipbookLokumSubtitle: "Gekookt in Koperen Ketels op Houtvuur",
  flipbookLokumStory: "Bereid volgens het Ottomaanse paleisrecept met vers granaatappelsap en knapperige dubbel geroosterde Antep pistaches.",
  flipbookLokumFeat1: "Zonder Gelatine & Glutenvrij",
  flipbookLokumFeat2: "Rijkelijk Gevuld met Pistache",
  flipbookLokumFeat3: "In Elegante Geschenkverpakking"
};
